import React, { useEffect, useState } from "react";
import { Users, ShoppingBag, TrendingUp, Bot, Wallet, AlertTriangle, Loader2, CheckCircle2 } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from "recharts";
import StatCard from "@/components/admin/StatCard";
import { useI18n } from "@/i18n/I18nContext";
import api from "@/lib/api";

export default function OverviewTab() {
  const { t } = useI18n();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats/overview").then(({ data }) => setStats(data));
  }, []);

  if (!stats) return null;

  const styleData = Object.entries(stats.top_styles).map(([name, value]) => ({ name, value }));
  const countryData = Object.entries(stats.sales_by_country).map(([name, value]) => ({ name, value }));

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <StatCard icon={Users} label={t("admin.totalUsers")} value={stats.total_users} />
        <StatCard icon={ShoppingBag} label={t("admin.totalOrders")} value={stats.total_orders} />
        <StatCard icon={TrendingUp} label={t("admin.revenue")} value={`${stats.revenue_eur}€`} accent />
        <StatCard icon={Wallet} label={t("admin.margin")} value={`${stats.margin_eur}€`} accent />
        <StatCard icon={Bot} label={t("admin.aiCost")} value={`$${stats.ai_cost_usd}`} />
        <StatCard icon={CheckCircle2} label={t("admin.completedOrders")} value={stats.completed_orders} />
        <StatCard icon={AlertTriangle} label={t("admin.failedOrders")} value={stats.failed_orders} />
        <StatCard icon={Loader2} label={t("admin.activeGenerations")} value={stats.active_generations} />
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {styleData.length > 0 && (
          <div className="rounded-2xl border border-border bg-card p-5">
            <p className="mb-4 text-sm font-medium text-muted-foreground">{t("admin.topStyles")}</p>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={styleData}>
                <XAxis dataKey="name" fontSize={11} />
                <YAxis fontSize={11} allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="value" fill="hsl(var(--primary))" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
        {countryData.length > 0 && (
          <div className="rounded-2xl border border-border bg-card p-5">
            <p className="mb-4 text-sm font-medium text-muted-foreground">{t("admin.salesByCountry")}</p>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={countryData}>
                <XAxis dataKey="name" fontSize={11} />
                <YAxis fontSize={11} allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="value" fill="hsl(var(--chart-2))" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}
